<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="80%"
      @close="close"
    >
      <el-form ref="form" label-width="120px" :model="form" :rules="rules">
        <!-- 门店 -->
        <el-form-item label="门店" prop="branchId">
          <el-select
            v-model="form.branchId"
            placeholder="请选择门店"
            class="fix-width"
            @change="branchChange"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.branchId"
              :label="item.title"
              :value="item.branchId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input
            v-model.trim="form.title"
            class="fix-width"
            placeholder="请输入标题"
          />
        </el-form-item>
        <el-form-item label="上架状态">
          <el-radio-group v-model="form.step" size="mini">
            <el-radio-button :label="1">未上架</el-radio-button>
            <el-radio-button :label="2">上架</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="餐厅" prop="restaurantIdList">
          <el-checkbox-group
            v-model="form.restaurantIdList"
            @change="restaurantChange"
          >
            <el-checkbox
              v-for="item of restaurantList"
              :label="item.restaurantId"
              :key="item.restaurantId"
            >
              {{ item.title }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="封面" prop="avatar">
          <el-upload
            class="avatar-uploader"
            :show-file-list="false"
            :action="QNUploadURL"
            :data="uploadToken"
            :on-success="image_success"
            :on-remove="image_remove"
          >
            <img v-if="form.avatar" :src="form.avatar" class="avatar" />
            <i v-else class="avatar-uploader-icon el-icon-plus"></i>
          </el-upload>
          <span>建议尺寸：164px * 164px</span>
        </el-form-item>
        <el-form-item label="轮播图" prop="imageList">
          <el-upload
            :action="QNUploadURL"
            :data="uploadToken"
            list-type="picture-card"
            :file-list="form.imageList"
            :on-success="imageList_success"
            :on-remove="imageList_remove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <!-- 菜品标签 -->
        <el-form-item label="菜品标签" prop="tagIdList">
          <el-checkbox-group v-model="form.tagIdList">
            <el-checkbox
              v-for="item of foodTagList"
              :label="item.tagId"
              :key="item.tagId"
            >
              {{ item.title }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <!-- 菜品标签 -->
        <el-form-item label="菜品价格" prop="defaultPrice">
          <el-input-number
            v-model="form.defaultPrice"
            class="fix-width"
            placeholder="请输入菜品价格"
          />
        </el-form-item>
        <el-form-item label="单位" prop="unit">
          <el-input
            v-model="form.unit"
            class="fix-width"
            placeholder="请输入单位"
          />
        </el-form-item>
        <el-form-item label="每日库存" prop="dailyStock">
          <el-input-number
            v-model="form.dailyStock"
            class="fix-width"
            placeholder="请输入每日库存"
          />
        </el-form-item>
        <el-form-item label="总库存" prop="totalStock">
          <el-input-number
            v-model="form.totalStock"
            class="fix-width"
            placeholder="请输入总库存"
          />
          注：每日库存和总库存设置一个即可，优先按每日库存计算
        </el-form-item>
        <!-- 打印机 -->
        <el-form-item
          label="点菜单打印机"
          prop="printerIdList"
          v-if="printerList.length > 0"
        >
          <el-checkbox-group v-model="form.printerIdList">
            <el-checkbox
              v-for="item of printerList"
              :label="item.printerId"
              :key="item.printerId"
            >
              {{ item.title }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <!-- 传菜单打印机 -->
        <el-form-item
          label="传菜单打印机"
          prop="snippetPrinterIdList"
          v-if="printerList.length > 0"
        >
          <el-checkbox-group v-model="form.snippetPrinterIdList">
            <el-checkbox
              v-for="item of printerList"
              :label="item.printerId"
              :key="item.printerId"
            >
              {{ item.title }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <!-- 菜品规格 -->
        <el-form-item label="烧法" prop="makeOptionList">
          <el-select
            v-model="form.makeOptionList"
            multiple
            filterable
            allow-create
            default-first-option
            class="fix-width"
            placeholder="请输入烧法(按Enter键输入下一个)"
          ></el-select>
        </el-form-item>
        <!-- 大份小份 -->
        <el-form-item label="规格列表" prop="specList">
          <el-select
            v-model="form.specList"
            @change="specChange"
            multiple
            filterable
            allow-create
            default-first-option
            class="fix-width"
            placeholder="请输入规格(按Enter键输入下一个)"
          ></el-select>
        </el-form-item>
        <!-- 规格价格 -->
        <el-form-item label="规格价格" v-if="form.specList.length > 0">
          <div v-for="(val, key) of form.defaultSpecPrice" :key="key">
            <span class="mr-10">{{ key }}</span>
            <el-input
              v-model="form.defaultSpecPrice[key]"
              class="fix-width mb-10"
              :placeholder="`请输入${key}价格`"
            />
          </div>
        </el-form-item>
        <!-- 规格每日库存 -->
        <el-form-item label="规格每日库存" v-if="form.specList.length > 0">
          <div v-for="(val, key) of form.specDailyStock" :key="key">
            <span class="mr-10">{{ key }}</span>
            <el-input
              v-model="form.specDailyStock[key]"
              class="fix-width mb-10"
              :placeholder="`请输入${key}每日库存`"
            />
          </div>
        </el-form-item>
        <!-- 规格每日库存 -->
        <el-form-item label="规格总库存" v-if="form.specList.length > 0">
          <div v-for="(val, key) of form.specTotalStock" :key="key">
            <span class="mr-10">{{ key }}</span>
            <el-input
              v-model="form.specTotalStock[key]"
              class="fix-width mb-10"
              :placeholder="`请输入${key}总库存`"
            />
          </div>
          注：每日库存和总库存设置一个即可，优先按每日库存计算
        </el-form-item>
        <!-- 打印机 -->
        <el-form-item label="说明" prop="text">
          <el-input
            v-model="form.text"
            type="textarea"
            class="fix-width"
            placeholder="请输入说明"
          />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.order" placeholder="排序" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createDish, updateDish, findTagAll, findAll } from '@/api/food'
import { getUploadToken } from '@/api/app'
import { QNUploadURL, QNHost } from '@/config/net.config'
import { getAllBranchs } from '@/api/branch'
import { findPrinterAll } from '@/api/settings'
export default {
  name: 'FoodDishEdit',
  emits: ['fetch-data'],
  data() {
    return {
      title: '',
      QNUploadURL,
      QNHost,
      uploadToken: null,
      restaurantList: [],
      printerList: [],
      foodTagList: [],
      branchList: [],
      form: {
        dishId: '',
        title: '',
        branchId: '',
        avatar: '',
        imageList: [],
        restaurantIdList: [],
        tagIdList: [], //菜品标签
        defaultPrice: '',
        unit: '',
        dailyStock: '',
        totalStock: '',
        printerIdList: [],
        snippetPrinterIdList: [],
        makeOptionList: [], //烧法
        specList: [],
        //规格价格
        defaultSpecPrice: {},
        //每日库存
        specDailyStock: {},
        specTotalStock: {},
        text: '',
        step: 2,
        order: 1,
      },
      rules: {
        title: [{ required: true, trigger: 'blur', message: '请输入标题' }],
        avatar: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value.length == 0) {
                callback(new Error('请上传封面'))
              } else {
                callback()
              }
            },
          },
        ],
        restaurantIdList: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value.length == 0) {
                callback(new Error('请至少选择一个餐厅'))
              } else {
                callback()
              }
            },
          },
        ],
        // branchId: [{ required: true, trigger: 'blur', message: '请选择门店' }],
        defaultPrice: [
          { required: true, trigger: 'blur', message: '请输入价格' },
        ],
        unit: [{ required: true, trigger: 'blur', message: '请输入单位' }],
        dailyStock: [],
        totalStock: [],
      },
      dialogFormVisible: false,
    }
  },
  methods: {
    branchChange(branchId) {
      this.findPrinterAll(branchId)
      //根据branchId查找餐厅
      this.findRestaurantAll(branchId)
      this.form.restaurantIdList = []
    },
    restaurantChange(value) {
      this.form.tagIdList = []
      //获取标签
      const res = this.form.restaurantIdList.join(',')
      this.findTagAll(res)
    },
    //获取所有打印机
    async findPrinterAll(branchId) {
      const res = await findPrinterAll({
        branchId: branchId || '',
      })
      if (!res) return
      this.printerList = res
    },
    //获取所有门店
    async getAllBranchs() {
      const res = await getAllBranchs({})
      if (!res) return
      this.branchList = res
    },
    //获取餐厅列表
    async findRestaurantAll(branchId) {
      const res = await findAll({
        branchId: branchId || '',
      })
      this.restaurantList = res || []
    },
    // 获取标签
    async findTagAll(restaurantId) {
      const res = await findTagAll({
        restaurantId: restaurantId || '',
      })
      this.foodTagList = res || []
    },
    specChange(val) {
      const specList = this.form.specList
      const defaultSpecPrice = {}
      const specDailyStock = {}
      const specTotalStock = {}
      if (specList.length > 0) {
        specList.forEach((item) => {
          defaultSpecPrice[item] = ''
          specDailyStock[item] = ''
          specTotalStock[item] = ''
        })
        this.form.defaultSpecPrice = defaultSpecPrice
        this.form.specDailyStock = specDailyStock
        this.form.specTotalStock = specTotalStock
      }
    },
    async showEdit(row) {
      if (row && row.dishId) {
        this.title = '修改菜品'
        this.form = Object.assign(this.form, row.basic)
        this.form.dishId = row.dishId
        this.form.defaultPrice = row.basic.price.defaultPrice
        this.form.defaultSpecPrice = row.basic.price.defaultSpecPrice
        this.form.dailyStock = row.basic.stock.dailyStock
        this.form.specDailyStock = row.basic.stock.specDailyStock
        this.form.totalStock = row.basic.stock.totalStock
        this.form.specTotalStock = row.basic.stock.specTotalStock
        this.form.title = row.title
        this.form.step = row.step
        this.form.branchId = row.extra.branchId
        this.findPrinterAll(row.extra.branchId)
        this.findRestaurantAll(row.extra.branchId)
        this.findTagAll(row.basic.restaurantIdList.join(','))
      } else {
        if(row){ // 复制数据
          this.form = Object.assign(this.form, row.basic)
          this.form.defaultPrice = row.basic.price.defaultPrice
          this.form.defaultSpecPrice = row.basic.price.defaultSpecPrice
          this.form.dailyStock = row.basic.stock.dailyStock
          this.form.specDailyStock = row.basic.stock.specDailyStock
          this.form.totalStock = row.basic.stock.totalStock
          this.form.specTotalStock = row.basic.stock.specTotalStock
          this.form.title = `${row.title}--复制`
          this.form.step = row.step
          this.form.branchId = row.extra.branchId
          this.findPrinterAll(row.extra.branchId)
          this.findRestaurantAll(row.extra.branchId)
          this.findTagAll(row.basic.restaurantIdList.join(','))
        }
        this.title = '新增菜品'
        this.findRestaurantAll()
        this.findTagAll()
      }
      this.getAllBranchs()
      this.dialogFormVisible = true
      const token = await getUploadToken({})
      this.uploadToken = { token: token.token }
    },
    // 图片
    imageList_remove(file, fileList) {
      this.form.imageList = fileList.map((e) => ({
        name: e.name,
        url: e.url,
      }))
    },
    image_remove(file, fileList) {
      this.form.avatar = ''
    },
    image_success(res, file) {
      if (!res.hash) {
        this.$message.error('图片上传失败')
        return
      }
      this.form.avatar = `${QNHost}/${res.hash}`
    },
    imageList_success(res, file) {
      if (!res.hash) {
        this.$message.error('图片上传失败')
        return
      }
      this.form.imageList.push({
        name: file.name,
        url: QNHost + '/' + res.hash,
      })
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          //校验规格价格 库存
          if (this.form.specList.length > 0) {
            try {
              this.form.specList.forEach((item) => {
                if (!this.form.defaultSpecPrice[item]) {
                  throw `请填写规格[${item}]价格`
                }
                if (!this.form.specDailyStock[item]) {
                  throw `请填写规格[${item}]每日库存`
                }
                if (!this.form.specTotalStock[item]) {
                  throw `请填写规格[${item}]总库存`
                }
              })
            } catch (error) {
              return this.$message.error(error)
            }
          }
          const dishId = this.form.dishId
          const data = Object.assign({}, this.form)
          this.$baseConfirm(
            `你确定要${dishId ? '修改' : '新增'}菜品吗`,
            null,
            async () => {
              dishId ? await updateDish(data) : await createDish(data)
              this.$baseMessage(
                `${dishId ? '修改' : '新增'}菜品成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              this.$emit('fetch-data')
              this.close()
            }
          )
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@mixin size($scale: 1, $type: small) {
  @if $type == large {
    width: 343px * $scale;
  } @else {
    width: 167px * $scale;
  }
  height: 167px * $scale;
}
.avatar-uploader {
  .avatar {
    border-radius: 6px;
    transition: all 0.3s ease-in-out;
    @include size;

    &.large {
      @include size(1, large);
    }
  }
}
.icon_avatar {
  width: 50px;
  height: 50px;
}
.avatar-uploader-icon {
  border: 1px dashed #c0ccda;
  background-color: #fbfdff;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
.tags {
  margin-bottom: 5px;
}
.tags + .tags,
.tags + .button-new-tag {
  margin-left: 10px;
}
.button-new-tag {
  // margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.disabled .el-upload--picture-card {
  display: none;
}
.fix-width {
  width: 500px;
}
.mb-10 {
  margin-bottom: 10px;
}
.tips {
  color: #aaaaaa;
  margin-left: 50px;
}
.el-icon-circle-plus-outline,
.el-icon-remove-outline {
  font-size: 32px;
  vertical-align: middle;
  cursor: pointer;
}

.el-icon-circle-plus-outline {
  color: #409eff;
}

.el-icon-remove-outline {
  color: #f56c6c;
  margin-left: 15px;
}

.mr-10 {
  margin-right: 10px;
}
.mb-10 {
  margin-bottom: 10px;
}
</style>
